import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { militaryBaseGuideView_template } from "../components/templates/militaryBaseGuideView_template";

declare var ko: any;
declare var page: any;

export class military_base_guide_view extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected baseView: militaryBaseGuideView_template;

    protected getModuleName() {
        return "military_base_guide_view";
    }

    buildContent(): Array<Element> {
        this.baseView = new militaryBaseGuideView_template("military_base_guide_view", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Military Base");

        return [this.baseView.build()];
    }

    public fillPage(): void {
        this.baseView.setBrand(this.getBrandId());
        this.getBase();
    }

    protected getBase(): void {
        this.loadingIn(this.baseView.builtTemplate);
        let usrReq_url = "/api/brand/" + this.getBrandId() + "/military-base-guides/bases/get/" + this.getBaseId() + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({})]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetBaseReturn;
        this.XHRHdl.execute();
    }

    protected onGetBaseReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response).data;
                obj.baseView.setBase(obj.withDisplayState(responseParsed.base, responseParsed.usStates || {}));
                obj.baseView.setHelpServiceRows(obj.buildHelpServiceRows(responseParsed.helpServiceCategories, responseParsed.helpServices, responseParsed.usStates || {}));
            });
            obj.loadingOut(obj.baseView.builtTemplate);
        };
    }

    protected buildHelpServiceRows(categories, helpServices, usStates = {}): Array<any> {
        const rows = [];
        categories = categories || [];
        helpServices = helpServices || [];
        categories.forEach((category) => {
            let matchingHelpService = null;
            helpServices.forEach((helpService) => {
                if (String(helpService.idCategory) == String(category.id)) {
                    matchingHelpService = helpService;
                }
            });
            rows.push({ category: category, helpService: this.withDisplayState(matchingHelpService, usStates) });
        });

        return rows;
    }

    protected withDisplayState(entity, usStates) {
        if (!entity || !entity.address || entity.address.country != "United States") {
            return entity;
        }

        const stateCode = String(entity.address.state || "").toUpperCase();
        if (stateCode && usStates[stateCode]) {
            entity.address.state = usStates[stateCode];
        }

        return entity;
    }

    protected cancel(): void {
        page("/brand/" + this.getBrandId() + "/military-base-guides/bases");
    }

    protected editBase(): void {
        page("/brand/" + this.getBrandId() + "/military-base-guides/bases/edit/" + this.getBaseId());
    }

    protected editHelpService(row): void {
        if (row.helpService) {
            page("/brand/" + this.getBrandId() + "/military-base-guides/help-services/edit/" + row.helpService.id);
        } else {
            page("/brand/" + this.getBrandId() + "/military-base-guides/bases/" + this.getBaseId() + "/help-services/add/" + row.category.id);
        }
    }

    protected viewHelpServiceOnSite(helpService): void {
        if (helpService) {
            this.openPathOnWebsite(helpService.slug);
        }
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    public getBaseId(): number {
        return Number(this.getVnAppZone().app.params.id);
    }

    public viewBaseOnSite(slug: string): void {
        this.openPathOnWebsite(slug);
    }

    protected openPathOnWebsite(path: string): void {
        if (!path) {
            return;
        }

        if (path.charAt(0) !== "/") {
          path = "/" + path;
        }

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        const hostnameParts = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if (hostnameParts.length == 3) {
            if (hostnameParts[0] != "emakicms") {
                urlBegin += hostnameParts[0] + ".";
            } else {
                isLocal = true;
            }
        }

        for (let i = 0; i < userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {
                const url = urlBegin + userBrands[i].domain.replace("www.", "") + (isLocal ? ("." + hostnameParts[2]) : "") + path;
                const element = document.createElement("a");
                element.setAttribute("href", url);
                element.setAttribute("target", "_blank");
                element.style.display = "none";
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_base_guide_view.ts